import mod from "-!./paperExerciseCreate.js?vue&type=script&lang=js&"; export default mod; export * from "-!./paperExerciseCreate.js?vue&type=script&lang=js&"